import React, { useContext } from 'react'
import { Context } from '../'

import { Button, HeaderFirstAction as FirstAction, Header, Icon } from '~ui'

export default function SplitViewMainHeader({ children, ...etc }) {
    const context = useContext(Context)

    return (
        <Header
            data-no-shadow
            data-window-inset
            {...etc}
            className='svMainHeader'>
            <FirstAction className='svSidebarShowButton'>
                <Button variant='ghost' href='' onClick={context && context.sidebar && context.sidebar.toggle}>
                    <Icon name='menu' />
                </Button>
            </FirstAction>

            {children}
        </Header>
    )
}
